import memoizeOne from 'memoize-one';
import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { applyApplicationUpdate, dismissApplicationUpdate, hasApplicationUpdate } from '~/ApplicationUpdate';
import { ApplicationState, ThunkDispatch } from '~/Store';
import { Link } from '~/UI/Button';

import { cancelFlashMessagesDismiss, removeFlashMessage, scheduleFlashMessagesDismiss } from './actions';
import FlashMessages from './FlashMessages';
import { Message } from './reducer';

function ApplicationUpdateLink() {
	const dispatch = useDispatch<ThunkDispatch<AnyAction>>();
	const build = useSelector((state: ApplicationState) => state.applicationUpdate.availableVersion?.build ?? null);

	return (
		<Link
			onClick={() => {
				void applyApplicationUpdate(() => dispatch(dismissApplicationUpdate(build))).catch(() => undefined);
			}}
		>
			update now
		</Link>
	);
}

const ApplicationUpdateMessage = {
	key: -1,
	type: 'update',
	text: (
		<span>
			{'New version of application is available, please '}
			<ApplicationUpdateLink />.
		</span>
	),
	dismissable: false,
};

const appendApplicationUpdateMessage = memoizeOne((messages, applicationUpdate) => {
	return hasApplicationUpdate(applicationUpdate) ? [...messages, ApplicationUpdateMessage] : messages;
});

function mapStateToProps(state: ApplicationState): {
	messages: Message[];
} {
	return {
		messages: appendApplicationUpdateMessage(state.flashMessages.messages, state.applicationUpdate),
	};
}

const actions = {
	onDismiss: removeFlashMessage,
	onMouseEnter: cancelFlashMessagesDismiss,
	onMouseLeave: scheduleFlashMessagesDismiss,
};

export default connect(mapStateToProps, actions)(FlashMessages);
